import { mergeStyleSets } from '@uifabric/merge-styles';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  root: {
    marginBottom: pxToRem(15),
  },
  actionsText: {
    fontWeight: 'normal',
  },
  primaryButton: {
    marginLeft: pxToRem(8),
  },
  secondaryButton: {
    marginLeft: pxToRem(8),
  },
  buttonDiv: {
    marginTop: pxToRem(8),
  },
  attachment: {
    display: 'inline-block',
    overflow: 'hidden',
  },
  uploader: {
    display: 'none',
  },
});
